import { useTranslation } from 'react-i18next';
import { LuClock } from 'react-icons/lu';

import { CHAT_WINDOW_STATES } from '~/features/whatsapp/constants/chatStatus';
import { deriveWindowState } from '~/features/whatsapp/utils/deriveChatStatus';
import { cn } from '~/utils/cnTailwind';

type Props = {
    lastInboundAt: number | null | undefined;
};

export const WindowBanner = ({ lastInboundAt }: Props) => {
    const { t } = useTranslation();
    const windowState = deriveWindowState(lastInboundAt);

    if (windowState === CHAT_WINDOW_STATES.NO_INBOUND_YET) return null;

    return (
        <div
            className={cn(
                'flex items-center gap-2 px-4 py-2 text-xs',
                windowState === CHAT_WINDOW_STATES.OPEN
                    ? 'bg-status-green-bg text-status-green-text'
                    : 'bg-status-yellow-bg text-status-yellow-text',
            )}
        >
            <LuClock className="shrink-0" />
            {windowState === CHAT_WINDOW_STATES.OPEN
                ? t('WHATSAPP_CHAT.WINDOW_BANNER.OPEN')
                : t('WHATSAPP_CHAT.WINDOW_BANNER.EXPIRED')}
        </div>
    );
};
